<template>
  <div>
    <block-title class="block-title" title="货品信息">
      <a-form-model
        class="form-content choose-type"
        :model="form"
        layout="inline"
      >
        <a-form-model-item :colon="false" label="货品导入方式" prop="type">
          <a-radio-group
            v-model="form.importType"
            class="radio-global"
            @change="changeRadio"
          >
            <a-radio
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
            >{{item.label}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <form-item
        ref="goodsForms"
        form-fef="goodsInfo"
        :form="form"
        v-bind="$attrs"
        :rules="formRules"
        :field-list="fieldList[form.importType]"
        @change="changeInfo"
      />
    </block-title>
  </div>
</template>

<script>
import Base from "@/api/base";
import BlockTitle from '@/components/panel/BlockTitle.vue'
import FormItem from './FormItem.vue'
import { GOODSFIELDLIST, GOODSTYPELIST, GOODSRULES, GOODSCATEGORYRULES } from '../constant'

export default {
  name: 'GoodsInfo',
  components: {
    BlockTitle,
    FormItem,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules: GOODSRULES,
      categoryRules: GOODSCATEGORYRULES,
      fieldList: GOODSFIELDLIST,
      typeList: GOODSTYPELIST,
    }
  },
  computed: {
    formRules() {
      if (this.form.importType === GOODSTYPELIST[0].value) {
        return this.rules
      }
      return {
        ...this.rules,
        ...this.categoryRules
      }
    },
  },
  created() {
    this.setGoodsCategory()
  },
  methods: {
    async setGoodsCategory() {
      const params = {
        status: 1,
        type: "publicGoods",
      };
      const goodsCategory = await Base.getDictionary(params);
      const categoryList = goodsCategory.map(item => {
        return {
          value: item.dictionaryCode,
          label: item.dictionaryName,
        }
      })
      this.fieldList.GOODS_CATEGORY[0].list = categoryList
    },
    // 切换导入选项时需重新校验是否填写完整新
    changeRadio() {
      this.$emit('changeFiled')
      this.$nextTick(() => {
        this.$refs.goodsForms.resetValidate()
        this.getValidate()
      })
    },
    getValidate() {
      this.$refs.goodsForms.changeInfo()
    },
    changeInfo(valid) {
      this.$emit('change', valid, this.index)
    }
  }
}
</script>